import React, { useMemo, useState } from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNAButtonProps, DNAText } from '@alucio/lux-ui';
import { useLoggerState } from 'src/state/machines/logger/LoggerProvider';
import { SendLogsButtonStates } from 'src/state/machines/logger/logger.selector';

type SendLogsButtonProps = {
  [key in keyof typeof SendLogsButtonStates]: {
    appearance: DNAButtonProps['appearance']
    status: DNAButtonProps['status']
    iconLeft?: DNAButtonProps['iconLeft']
    onPress: () => void
    children: string
  }
}

const S = StyleSheet.create({
  debugWidth: {
    maxWidth: '80dvw'
  }
})

const SendLogs: React.FC = () => {
  const [showErrMsg, setShowErrMsg] = useState<boolean>(false)
  const {
    sendLogsToCloudWatch,
    canSendLogs,
    sendLogsButtonState,
    sendLogsError,
  } = useLoggerState()

  const sendLogsButtonStates: SendLogsButtonProps = {
    idle: {
      appearance: 'outline',
      status: 'tertiary',
      onPress: sendLogsToCloudWatch,
      children: 'Send logs',
    },
    successfullySentLogs: {
      appearance: 'filled',
      status: 'success',
      iconLeft: 'check',
      children: 'Sent',
      onPress: () => {},
    },
    failedToSendLogs: {
      appearance: 'filled',
      status: 'danger',
      iconLeft: 'x',
      onPress:  () => {},
      children: 'Failed',
    },
  }
  const sendLogsButtonProps = useMemo(
    () => sendLogsButtonStates[sendLogsButtonState],
    [sendLogsButtonState]
  )

  const displayErrorMsg = showErrMsg && sendLogsError

  return (
    <DNABox
      appearance='col'
      spacing='lg'
      style={S.debugWidth}>
      <DNAButton
        {...sendLogsButtonProps}
        disabled={!canSendLogs}
        onLongPress={() => setShowErrMsg(p => !p)}
      />
      {
        displayErrorMsg
          ? (
            <DNAText status='warning'>
              {
                JSON.stringify(
                  {
                    error: sendLogsError,
                    cause: {
                      name: sendLogsError.cause?.errors?.at(0)?.name,
                      stack: sendLogsError.cause?.errors?.at(0)?.stack
                    }
                  },
                  null,
                  2
                )
              }
            </DNAText>
          )
          : null
      }
    </DNABox>
  )
}

export default SendLogs;
